'use strict';

let videoElements = document.querySelectorAll('.picture-video video');

let interceptContextMenu = function (event) {
  event.preventDefault();
  return false;
};

var videosWithInitialAutoplay = [];
for (let i = 0; i < videoElements.length; i++) {
  if (videoElements[i].getAttribute('data-autoplay-in-view') !== null) {
    // don`t start before the video is visible / in viewport
    videoElements[i].removeAttribute('autoplay');
    let el = { video: videoElements[i], userPaused: false, paused: false };
    videosWithInitialAutoplay.push(el);
    el.video.onpause = function () {
      if (el.paused === false) {
        el.userPaused = true;
      }
    };
    el.video.onplay = function () {
      el.userPaused = false;
      el.paused = false;
    };
    el.video.muted = true;
  }

  videoElements[0].addEventListener('contextmenu', interceptContextMenu, false);
  //disabling Context Menu for each element
}

let isElementInViewport = function (element) {
  let rect = element.getBoundingClientRect();
  if (rect.height === 0) {
    return false;
  }
  let yOffset = rect.height - rect.height * 0.3;
  return (
    rect.top >= 0 - yOffset &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + yOffset &&
    rect.left >= 0 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

let handler = function () {
  for (let i = 0; i < videosWithInitialAutoplay.length; i++) {
    let element = videosWithInitialAutoplay[i];
    if (isElementInViewport(element.video)) {
      if (element.userPaused === false) {
        if (element.video.play !== undefined) {
          element.video.play();
        } else {
          element.video.setAttribute('autoplay', '');
        }
      }
      element.paused = false;
    } else {
      if (element.video.pause !== undefined) {
        element.paused = true;
        element.video.pause();
      } else {
        element.video.removeAttribute('autoplay');
      }
    }
  }
};

document.onvisibilitychange = function () {
  for (let i = 0; i < videosWithInitialAutoplay.length; i++) {
    if (document.visibilityState === 'visible' && isElementInViewport(videosWithInitialAutoplay[i].video)) {
      videosWithInitialAutoplay[i].video.play();
    } else {
      videosWithInitialAutoplay[i].video.pause();
    }
  }
};

addEventListener('DOMContentLoaded', handler, false);
addEventListener('load', handler, false);
addEventListener('scroll', handler, false);
addEventListener('resize', handler, false);
